import clsx from 'clsx'
import DashboardCard from './DashboardCard'

const sizeMap = {
  primary: 'text-kpi',
  secondary: 'text-kpi2',
  compact: 'text-[clamp(1.4rem,4vw,2rem)]'
}

const toneMap = {
  primary: 'text-primary',
  success: 'text-success',
  danger: 'text-danger',
  info: 'text-info',
  default: 'text-text'
}

const KpiCard = ({
  title,
  value,
  subtitle,
  tone = 'primary',
  size = 'primary',
  align = 'center',
  className,
  valueClassName,
  wrapper = true
}) => {
  const alignClass =
    align === 'left' ? 'text-left items-start' : align === 'right' ? 'text-right items-end' : 'text-center items-center'

  const content = (
    <div className={clsx('flex w-full min-w-0 flex-col gap-1', alignClass)}>
      {title && <div className='text-label sm:text-sm font-medium text-muted'>{title}</div>}
      <div className={clsx('w-full min-w-0 font-bold tabular-nums', sizeMap[size] || sizeMap.primary, toneMap[tone] || toneMap.default, valueClassName)}>
        {value}
      </div>
      {subtitle && <div className='text-label sm:text-sm text-muted'>{subtitle}</div>}
    </div>
  )

  if (!wrapper) return <div className={clsx('w-full min-w-0', className)}>{content}</div>

  return (
    <DashboardCard className={clsx('flex justify-center min-w-0', className)}>
      {content}
    </DashboardCard>
  )
}

export default KpiCard
